import { styled } from '@mui/material/styles';

type ContainerProps = {
  'data-is-current': boolean;
};

export const Container = styled('div')<ContainerProps>(({ theme, ...props }) => ({
  display: 'flex',
  alignItems: 'center',

  columnGap: '1.2rem',

  color: props['data-is-current'] ? theme.colors.base01 : theme.colors.base03,
}));

type StepNumberContainerProps = {
  'data-is-current': boolean;
};

export const StepNumberContainer = styled('div')<StepNumberContainerProps>(({ theme, ...props }) => ({
  width: '2rem',
  height: '2rem',

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  borderRadius: '50%',

  color: props['data-is-current'] ? theme.colors.base01 : theme.colors.base02,
  backgroundImage: props['data-is-current'] ? theme.colors.gradient01 : theme.colors.base01,
  backgroundColor: props['data-is-current'] ? 'none' : theme.colors.base04,
}));
